"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _reactApollo = require("react-apollo");
var _reactRedux = require("react-redux");
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _dealerLocator = _interopRequireDefault(require("./dealer-locator"));
var _types = _interopRequireDefault(require("./types"));
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
var _templateObject, _p;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;

// INFO: Google Maps requires a different search term for some markets,
// i.e.: `pt` doesn't return any result, hence the maps is never loaded.
var countryCodeSearchLookup = {
  'language-masters': 'UK',
  gb: 'UK',
  it: 'ITALY',
  pt: 'Portugal',
  us: 'USA',
  at: 'Germany',
  bh: 'Bahrain',
  qa: 'Qatar',
  kw: 'Kuwait',
  om: 'Oman',
  eg: 'Egypt',
  gr: 'Greece',
  ie: 'Ireland',
  no: 'Norway',
  ph: 'Philippines',
  es: 'Spain',
  ca: 'Canada'
};
var getSearchTermFromMarket = function getSearchTermFromMarket(market) {
  return countryCodeSearchLookup[market] || market;
};
var DEALERS = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query searchDealer(\n    $latitude: Float!\n    $longitude: Float!\n    $market: String!\n    $language: String!\n    $radius: Float!\n    $service: DepartmentCode\n    $filters: String\n    $path: String\n    $province: String\n  ) {\n    searchDealer(\n      path: $path\n      criteria: {\n        latitude: $latitude\n        longitude: $longitude\n        market: $market\n        language: $language\n        radius: $radius\n        service: $service\n        filters: $filters\n        province: $province\n      }\n    ) {\n      name\n      id\n      dealershipMarketId\n      url\n      carServiceCTA\n      testDriveCTA\n      dealerFilterTags\n      email\n      rating\n      logo\n      searchInventoryUrl\n      scheduleServiceUrl\n      phone {\n        phoneType\n        countryCode\n        areaCode\n        phoneNumber\n        extensionNumber\n      }\n      address {\n        addressLine1\n        addressLine2\n        addressLine3\n        postalArea\n        municipality\n        district\n        longitude\n        latitude\n        city\n      }\n      dealerDepartments {\n        name\n        code\n        email\n        phone {\n          phoneType\n          countryCode\n          areaCode\n          phoneNumber\n          extensionNumber\n        }\n        workingHours {\n          dayOfTheWeek\n          openTime\n          closeTime\n          status\n        }\n      }\n    }\n  }\n"])));
var getDealerNameAsParam = function getDealerNameAsParam(dealerName) {
  // Replace unsafe URL characters from dealer name
  // with dashes blank strings or keyword and
  var dealerNameAsParam = dealerName.toLowerCase().replace(/ & | |\.|\)|\(|'|,+/g, function (match) {
    var valueToSub = '';
    if (match === ' & ') {
      valueToSub = '-and-';
    } else if (match === ' ' || match === '.') {
      valueToSub = '-';
    }
    return valueToSub;
  });
  // Trim any groups of 2 or more dashes to a single dash
  return dealerNameAsParam.replace(/-{2,9}/g, '-');
};
var getMatchedDealerFromParam = function getMatchedDealerFromParam(dealers, dealerParam) {
  return dealers.find(function (currentDealer) {
    var nameAsParam = currentDealer.name ? getDealerNameAsParam(currentDealer.name) : currentDealer.name;
    return nameAsParam === dealerParam;
  });
};
var DealerLocatorGraphQl = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DealerLocatorGraphQl, _Component);
  DealerLocatorGraphQl.resourceType = function resourceType() {
    return 'DealerLocator_1_0_0';
  };
  function DealerLocatorGraphQl(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var defaultLatitude = props.defaultLatitude,
      defaultLongitude = props.defaultLongitude,
      countryCode = props.countryCode;
    _this.state = {
      userLocation: {
        lat: defaultLatitude,
        lng: defaultLongitude
      },
      stateCode: '',
      defaultLocation: {
        lat: defaultLatitude,
        lng: defaultLongitude
      },
      dealerShipType: 'all',
      countryCode: countryCode,
      googleMapSettings: {
        zoom: 12,
        center: {
          lat: defaultLatitude,
          lng: defaultLongitude
        }
      },
      selectedDealer: undefined,
      isInitialMapLoad: true,
      showList: false,
      searchValue: '',
      placeChanged: false
    };
    _this.updateDealership = _this.updateDealership.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateSelectedDealer = _this.updateSelectedDealer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateMapCentre = _this.updateMapCentre.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateStateCode = _this.updateStateCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.initializeMap = _this.initializeMap.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInitialMapState = _this.setInitialMapState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInitialMapGeocodeFromCountryCode = _this.setInitialMapGeocodeFromCountryCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setSearchValue = _this.setSearchValue.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlacesChangedEvent = _this.handlePlacesChangedEvent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setIsInitialMapLoad = _this.setIsInitialMapLoad.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DealerLocatorGraphQl.prototype;
  _proto.handlePlacesChangedEvent = function handlePlacesChangedEvent() {
    this.setState({
      placeChanged: true
    });
  };
  _proto.setInitialMapGeocodeFromCountryCode = function setInitialMapGeocodeFromCountryCode(_maps, _map) {
    var _this2 = this;
    var _this$props = this.props,
      market = _this$props.market,
      defaultMapZoom = _this$props.defaultMapZoom;
    var geocoder = new _maps.Geocoder();
    geocoder.geocode({
      address: getSearchTermFromMarket(market)
    }, function (results, status) {
      if (status === _maps.GeocoderStatus.OK) {
        _map.setZoom(handleNestedProp(_this2, 'this.props.defaultMapZoom') !== ' ' ? defaultMapZoom : 6);
        // _map.setCenter(results[0].geometry.location);
      } else {
        console.error('Initial address could not be set on Maps:', status);
      }
    });
  };
  _proto.setInitialMapState = function setInitialMapState() {
    var _this$props2 = this.props,
      defaultLatitude = _this$props2.defaultLatitude,
      defaultLongitude = _this$props2.defaultLongitude,
      market = _this$props2.market;
    this.setState({
      userLocation: {
        lat: defaultLatitude,
        lng: defaultLongitude
      },
      defaultLocation: {
        lat: defaultLatitude,
        lng: defaultLongitude
      },
      googleMapSettings: {
        center: {
          lat: defaultLatitude,
          lng: defaultLongitude
        }
      },
      countryCode: market
    });
  };
  _proto.setSearchValue = function setSearchValue(searchValue) {
    this.setState({
      searchValue: searchValue
    });
  };
  _proto.setIsInitialMapLoad = function setIsInitialMapLoad(_bool) {
    this.setState({
      isInitialMapLoad: _bool
    });
  };
  _proto.updateMapCentre = function updateMapCentre(location, zoom) {
    return this.setState({
      userLocation: {
        lat: location.lat,
        lng: location.lng
      },
      googleMapSettings: {
        center: location,
        zoom: zoom
      },
      isInitialMapLoad: false,
      showList: true
    });
  };
  _proto.updateStateCode = function updateStateCode(stateCode) {
    return this.setState({
      stateCode: stateCode
    });
  };
  _proto.updateDealership = function updateDealership(userLocation, dealerShipType) {
    return this.setState(function () {
      return {
        userLocation: userLocation,
        dealerShipType: dealerShipType
      };
    });
  };
  _proto.initializeMap = function initializeMap() {
    var isInitialMapLoad = this.state.isInitialMapLoad;
    if (isInitialMapLoad) {
      return this.setInitialMapState();
    }
  };
  _proto.updateSelectedDealer = function updateSelectedDealer(dealer) {
    var _this$props3 = this.props,
      compProps = _this$props3.compProps,
      _this$props3$router = _this$props3.router,
      push = _this$props3$router.push,
      routeParamOne = _this$props3$router.params.routeParamOne,
      pathname = _this$props3$router.location.pathname,
      market = _this$props3.market;
    var useRouteParams = compProps ? compProps.useRouteParams : null;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer && dealer) {
      var name = dealer.name;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dealer_selected',
        comp_page: {
          dealer_name: name.toLowerCase()
        }
      });
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer && dealer) {
      window.dataLayer = window.dataLayer || [];
      var dealershipMarketId = dealer.dealershipMarketId,
        _name = dealer.name;
      window.dataLayer.push({
        event: 'dealer_selected',
        dealerId: dealershipMarketId,
        dealerName: _name.toLowerCase()
      });
    }

    /* Set PostalCode of dealer in storage for clickshop bridge */
    if (dealer) {
      var address = dealer.address;
      var postalArea = address.postalArea;
      if (postalArea) {
        (0, _commonLibs.setDealerPostalCodeInDealerCache)(postalArea);
      } else {
        var latitude = address.latitude,
          longitude = address.longitude;
        this.retryGeocodeWithLatlng(latitude, longitude);
      }
    }
    if (useRouteParams) {
      // Remove trailing slash from URL if present
      var updatedPath = pathname.charAt(pathname.length - 1) === '/' ? pathname.substr(0, pathname.length - 2) : pathname;
      if (dealer && dealer.name) {
        // Push from dealer list view back to dealer detail view
        push({
          pathname: updatedPath + "/" + getDealerNameAsParam(dealer.name)
        });
      } else if (routeParamOne) {
        // Push from dealer details view back to dealer list view
        push({
          pathname: "" + updatedPath.replace("/" + routeParamOne, '')
        });
      }
    } else {
      return this.setState({
        selectedDealer: dealer,
        showList: true
      });
    }
  };
  _proto.retryGeocodeWithLatlng = function retryGeocodeWithLatlng(lat, lng) {
    var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var lookup = {
      latLng: latLng
    };
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        (0, _commonLibs.setDealerPostalCodeInDealerCache)(postalCode);
      }
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props4 = this.props,
      theme = _this$props4.theme,
      pageData = _this$props4.data,
      initialRadius = _this$props4.initialRadius,
      market = _this$props4.market,
      language = _this$props4.language,
      path = _this$props4.path,
      compProps = _this$props4.compProps,
      routeParamOne = _this$props4.router.params.routeParamOne;
    var useRouteParams = compProps ? compProps.useRouteParams : null;
    var _this$state = this.state,
      defaultLocation = _this$state.defaultLocation,
      dealerShipType = _this$state.dealerShipType,
      countryCode = _this$state.countryCode,
      selectedDealer = _this$state.selectedDealer,
      googleMapSettings = _this$state.googleMapSettings,
      userLocation = _this$state.userLocation,
      isInitialMapLoad = _this$state.isInitialMapLoad,
      showList = _this$state.showList,
      searchValue = _this$state.searchValue,
      placeChanged = _this$state.placeChanged,
      stateCode = _this$state.stateCode;
    var additionalFilters = pageData.additionalFilters;
    function setRadius() {
      if (isInitialMapLoad) {
        return initialRadius;
      }
      return pageData.searchRadius;
    }
    function setLatLng() {
      if (isInitialMapLoad) {
        return [defaultLocation.lat, defaultLocation.lng];
      }
      return [userLocation.lat, userLocation.lng];
    }
    var _radius = setRadius();
    var _queryLatLng = setLatLng();
    var useTypeAsFilter = false;
    if (additionalFilters) {
      useTypeAsFilter = additionalFilters.findIndex(function (filter) {
        return dealerShipType === filter.value;
      }) !== -1;
    }
    var queryParams = {
      latitude: _queryLatLng[0],
      longitude: _queryLatLng[1],
      service: useTypeAsFilter ? 'all' : dealerShipType,
      filters: useTypeAsFilter ? dealerShipType : null,
      radius: _radius,
      market: market,
      language: language,
      path: path
    };
    if (market === 'ca') {
      queryParams.province = stateCode;
    }
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: DEALERS,
      variables: queryParams
    }, function (_ref) {
      var loading = _ref.loading,
        data = _ref.data;
      if (!data) {
        return _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null));
      }
      var activeDealer = selectedDealer;
      if (useRouteParams && routeParamOne && data.searchDealer) {
        activeDealer = getMatchedDealerFromParam(data.searchDealer, routeParamOne);
      }
      return /*#__PURE__*/_react["default"].createElement(_dealerLocator["default"], {
        theme: theme,
        data: data,
        loading: loading,
        pageData: pageData,
        updateDealership: _this3.updateDealership,
        updateMapCentre: _this3.updateMapCentre,
        updateStateCode: _this3.updateStateCode,
        updateSelectedDealer: _this3.updateSelectedDealer,
        defaultLocation: defaultLocation,
        countryCode: countryCode,
        selectedDealer: activeDealer,
        googleMapSettings: googleMapSettings,
        userLocation: userLocation,
        setInitialMapGeocodeFromCountryCode: _this3.setInitialMapGeocodeFromCountryCode,
        isInitialMapLoad: isInitialMapLoad,
        setIsInitialMapLoad: _this3.setIsInitialMapLoad,
        showList: showList,
        radius: _radius,
        defaultRadius: initialRadius,
        setSearchValue: _this3.setSearchValue,
        searchValue: searchValue,
        handlePlacesChangedEvent: _this3.handlePlacesChangedEvent,
        placeChanged: placeChanged,
        market: market,
        path: path
      });
    });
  };
  return DealerLocatorGraphQl;
}(_react.Component);
DealerLocatorGraphQl.defaultProps = {
  compProps: {}
};
var mapStateToProps = function mapStateToProps(state, props) {
  var market = props.market || state.Config.market;
  return {
    currencyFormat: props.currencyFormat || state.Config.currencyFormat,
    countryCode: market === 'language-masters' ? 'gb' : market,
    defaultLang: props.defaultLang || state.Config.defaultLang,
    measurementSystem: props.measurementSystem || state.Config.measurementSystem,
    googleAPIKeyFromConfig: props.googleAPIKeyFromConfig || state.Config.googleApiKey,
    market: market === 'language-masters' ? 'gb' : market,
    language: props.language || state.Config.language,
    dateFormat: props.dateFormat || state.Config.dateFormat,
    localeCode: props.localeCode || state.Config.localeCode,
    distance: props.distance || state.Config.distance,
    defaultMapZoom: props.defaultMapZoom || state.Config.defaultMapZoom,
    initialRadius: props.initialRadius || state.Config.initialRadius,
    defaultLatitude: props.defaultLatitude || state.Config.defaultLatitude,
    defaultLongitude: props.defaultLongitude || state.Config.defaultLongitude
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(DealerLocatorGraphQl));
exports["default"] = _default;